<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            type="text"
                            icon="fa fa-search"
                            placeholder="Pesquisar..."
                            v-model="search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="novo_aviso()">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                            <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                            @click="viewMode = 'A'">
                                Ativos
                            </button>
                            <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                            @click="viewMode = 'T'">
                                Todos
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state msg="Nenhum aviso identificado" icon="fas fa-search" v-if="!lista.length" />

        <template v-else>

            <ul class="list-group">
                <li class="list-group-item" v-for="(aviso, iax) in lista" :key="iax">
                    <div class="d-flex justify-content-between">
                        <div>
                            <a href="#" @click.prevent="editar(aviso)" class="card-link h4">
                                {{ aviso.search }}
                            </a>
                            <div class="small">
                                <span v-if="aviso.usuario">
                                    {{ aviso.usuario.st_login }}, 
                                </span>
                                <span v-if="aviso.created_at">
                                    {{ $util.getFormatDate(aviso.created_at) }}
                                    {{ aviso.created_at.substr(11,5) }}
                                </span>
                            </div>
                            <div v-if="!aviso.fl_enviar_para_todos && !aviso.acessos.length" class="small text-danger mt-2">
                                <i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
                                Necessário definir os destinatários do aviso.
                            </div>
                        </div>
                        <span>

                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + iax" 
                                    v-model="aviso.fl_ativo" 
                                    @change="toggle(aviso)">
                                <label class="custom-control-label" :for="'ativo-' + iax"></label>
                            </div>
                            <div v-else>
                                <button type="button" class="btn btn-outline-primary btn-sm mr-1"
                                    @click="$refs.anexo.abrir_anexar_arquivo(aviso)">
                                    <i class="fa fa-paperclip" aria-hidden="true"></i>
                                    <span class="badge badge-primary ml-1" v-if="aviso.arquivos.length">
                                        {{ aviso.arquivos.length }}
                                    </span>
                                </button>
                                <button type="button" class="btn btn-outline-secondary btn-sm mr-1" @click="enviar_agora (aviso)">
                                    <i class="fas fa-paper-plane mr-1"></i>
                                    Enviar Agora
                                </button>
                                <button type="button" class="btn btn-outline-secondary btn-sm mr-1" @click="ver_leituras (aviso)">
                                    <i class="fas fa-book-reader"></i>
                                    <span class="badge badge-secondary ml-1">{{ aviso.leituras_count }}</span>
                                </button>
                                <button type="button" class="btn btn-sm" @click="acessos(aviso)" v-if="!aviso.fl_enviar_para_todos"
                                    :class="!aviso.acessos.length ? 'btn-primary' : 'btn-outline-secondary'">
                                    <i class="fas fa-user-plus mr-1"></i>
                                    <span class="badge badge-secondary" v-if="aviso.acessos.length">{{ aviso.acessos.length }}</span>
                                    <span v-else>Destinatários</span>
                                </button>
                                <button type="button" class="btn btn-secondary btn-sm" disabled v-else>
                                    <i class="fas fa-user-plus mr-1"></i>
                                    Todos
                                </button>
                            </div>
                        </span>
                    </div>
                </li>
            </ul>

            <pre class="alert alert-info" v-if="false">{{ dados }}</pre>

        </template>

        <anexar-marcacao-documentos
            model="aviso"
            campo_id="id_aviso"
            ref="anexo" />

        <!-- Modal -->
        <div class="modal fade" id="editarAvisoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Aviso {{ item.id_aviso ? '#' + item.id_aviso : 'Novo' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Título"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Início"
                                    type="datetime-local"
                                    :validate="validate"
                                    v-model="item.dt_vigencia_inicio" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Fim"
                                    type="datetime-local"
                                    :validate="validate"
                                    v-model="item.dt_vigencia_termino" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Conteúdo"
                                    type="textarea"
                                    rows="5"
                                    :validate="validate"
                                    required
                                    v-model="item.st_conteudo" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Conteúdo em HTML"
                                    type="checkbox-group"
                                    v-model="item.fl_html" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Exibir para Todos"
                                    type="checkbox-group"
                                    v-model="item.fl_enviar_para_todos" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="aviso" :id="item.id_aviso" v-if="item.id_aviso" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ item.id_aviso ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="leiturasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content" v-if="leituras">
                    <div class="modal-header">
                        <h5 class="modal-title">Leituras</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="alert alert-info">
                            {{ leituras.search }}
                            <span v-if="leituras.id_aviso">
                                #{{ leituras.id_aviso }}
                            </span>
                        </p>

                        <az-empty-state msg="Nenhuma leitura identificada." v-if="!leituras.leituras.length" />

                        <ul class="list-group" v-else>
                            <li class="list-group-item" v-for="(leitura, ilx) in leituras.leituras" :key="ilx">
                                {{ leitura.usuario.pessoa.st_nome }},
                                <span v-if="leitura.created_at">
                                    {{ $util.getFormatDate(leitura.created_at) }}
                                    {{ leitura.created_at.substr(11,8) }}
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()"  />
                                
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../shared/forms/AzInput.vue';
import AzPeriodo from '../shared/forms/AzPeriodo.vue';
import AzSubmit from '../util/AzSubmit.vue';
import AzEmptyState from '../util/AzEmptyState.vue';
import EdicaoAcessos from '../cadastros/shared/EdicaoAcessos.vue';
import AzAuditLogButton from '../util/AzAuditLogButton.vue';
import AnexarMarcacaoDocumentos from '../modulos/recepcao/AnexarMarcacaoDocumentos.vue';

export default {
    data() { 
        return { 
            dados: null,
            item: null, 
            validate: false, 
            filtros: { 
                periodo: 'm', 
            },
            search: "", 
            viewMode: "A", 
            leituras: null, 
        }
    },

    computed: { 
        lista: function () { 
            if ( !this.dados )
                return [];

            const reg = this.$util.getregex(this.search);

            return this.dados.filter (item =>  
                ( this.viewMode == 'T' || item.fl_ativo ) && 
                ( !this.search || reg.test(JSON.stringify(item)) )
            );
        }
    },
    
    components: { 
        AzInput, 
        AzSubmit, 
        AzPeriodo, 
        AzEmptyState, 
        EdicaoAcessos, 
        AzAuditLogButton, 
        AnexarMarcacaoDocumentos
    }, 

    methods: { 
        enviar_agora (aviso) { 
            this.$util.atualizar(this, { 
                service: 'avisos',
                func: 'enviar_agora',
                dados: { 
                    id_aviso: aviso.id_aviso,
                },
                toast: true, 
                msg: 'Aviso enviado.',
            });
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'avisos',
                dados: item,
            });

        },

        acessos(item) { 
          this.$refs.acessos.abrir('App\\azure\\aviso', item.id_aviso, item.search);
        },  

        editar(item) { 
            this.item = null;
            this.validate = false;

            this.$nextTick(() => { 
                this.item = _.cloneDeep(item);
                $('#editarAvisoModal').modal('show');
            })
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'avisos',
                dados: this.item, 
                modal: 'editarAvisoModal',
                reload: true, 
                toast: true, 
            });
        },

        novo_aviso () { 
            this.validate = false;
            this.item = null;
            
            this.$nextTick(() => { 
                this.item = { 
                    id_aviso: null, 
                    st_titulo: "", 
                    st_conteudo: "", 
                    fl_html: false,
                    fl_enviar_para_todos: false, 
                    fl_ativo: true, 
                };

                $('#editarAvisoModal').modal('show');
            })
        },

        ver_leituras (aviso) { 
            this.leituras = {
                search: "Verificando leituras...",
                leituras: [],
            };

            this.$nextTick(() => { 
                $('#leiturasModal').modal('show');
            });

            this.$util.load(this, { 
                service: 'avisos',
                func: 'show',
                with: ['leituras.usuario.pessoa:id_pessoa,st_nome'],
                parms: { 
                    with: ['leituras'],
                    id: aviso.id_aviso, 
                },
                loadTo: res => { 
                    this.leituras = res;
                }
            });
        },

        load() { 
            this.$util.load(this, { 
                service: 'avisos',
                func: 'index',
                parms: { 
                    config: true,
                    ...this.filtros, 
                },
            });
        }
    },

    mounted() { 

        this.load ();

        this.breadcrumb = [
                { name: "Avisos", path: "/avisos"},
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    }
}
</script>